(function () {
var $6e2adab23bbff3d3$exports = {};
(function() {
    const task = getTaskID();
    if (task) {
        console.log(`Jira taskId: ${task}`);
        console.log(`URL: https://pixrig.atlassian.net/browse/${task}`);
        console.log("Hash commit: ", "42d40c8724478f5de30d1b4d4d5fece4e1f7d585");
    }
    function getTaskID() {
        const commitMessage = undefined;
        if (commitMessage) {
            const taskID = commitMessage.match(/EN-\d+/);
            if (taskID) return taskID[0];
        }
        return null;
    }
})();

})();
//# sourceMappingURL=a-shoot.d3fcea5e.js.map
